import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { StartComponent } from './start/start.component';
import { AuthGuardService } from '../../core/services/auth/auth-guard.service';

export const startRoutes: Routes = [
    {
        path: 'start',
        component: StartComponent,
        canActivate: [AuthGuardService],
    },
];

export const startRouting: ModuleWithProviders<RouterModule> = RouterModule.forChild(startRoutes);
